import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { AdminGuard } from './shared/guards/admin.guard';
import { InstructorGuard } from './shared/guards/instructor.guard';
import { ParticipantGuard } from './shared/guards/participant.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'admin', pathMatch: 'full' },
  {
    path: 'instructor',
    canLoad: [AuthGuard],
    canActivate: [InstructorGuard],
    loadChildren: () =>
      import('./instructor/instructor.module').then((m) => m.InstructorModule),
  },
  {
    path: 'participant',
    canLoad: [AuthGuard],
    canActivate: [ParticipantGuard],
    loadChildren: () =>
      import('./participant/participant.module').then(
        (m) => m.ParticipantModule,
      ),
  },
  {
    path: 'admin',
    canLoad: [AuthGuard],
    canActivate: [AdminGuard],
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
];

export const routing: ModuleWithProviders<any> = RouterModule.forRoot(routes);
